import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-950 text-background-100">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <Link to="/" className="font-heading text-xl text-background-50 whitespace-nowrap">
                穿搭换装指南
              </Link>
              <p className="mt-3 text-sm text-background-300 leading-relaxed">
                专注女性穿搭换装技巧分享，帮助每一位爱美女性找到属于自己的优雅穿搭方式。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-base text-background-50 mb-4">内容分类</h4>
              <div className="flex flex-col gap-2">
                {categories.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-300 hover:text-background-100 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>

            <div>
              <h4 className="font-heading text-base text-background-50 mb-4">快速链接</h4>
              <div className="flex flex-col gap-2">
                <Link to="/" className="text-sm text-background-300 hover:text-background-100 transition-colors whitespace-nowrap">
                  首页
                </Link>
                <Link to="/about" className="text-sm text-background-300 hover:text-background-100 transition-colors whitespace-nowrap">
                  关于我们
                </Link>
                <a href="#contact" className="text-sm text-background-300 hover:text-background-100 transition-colors whitespace-nowrap">
                  联系我们
                </a>
              </div>
            </div>

            <div>
              <h4 className="font-heading text-base text-background-50 mb-4">关注我们</h4>
              <div className="flex gap-4">
                <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors" aria-label="微信">
                  <i className="ri-wechat-line text-lg text-background-100"></i>
                </a>
                <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors" aria-label="微博">
                  <i className="ri-weibo-line text-lg text-background-100"></i>
                </a>
                <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors" aria-label="小红书">
                  <i className="ri-bookmark-line text-lg text-background-100"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-background-400">
              &copy; {currentYear} 穿搭换装指南 版权所有
            </p>
            <div className="flex gap-6">
              <a href="#" className="text-sm text-background-400 hover:text-background-200 transition-colors whitespace-nowrap">隐私政策</a>
              <a href="#" className="text-sm text-background-400 hover:text-background-200 transition-colors whitespace-nowrap">使用条款</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}